import { Dispatch } from "redux";
import {
  GETTING_URL,
  GET_URL_SUCCESS,
  GET_URL_ERROR,
  GetUrlTypes,
  GETTING_ISSUERS,
  GET_ISSUERS_SUCCESS,
  GET_ISSUERS_ERROR,
  InstrumentTypes,
} from "../config/ActionTypes";
import { Issuer, PurchaseRequest, Session } from "../config/types";
import { instrumentsService } from "../../services/instruments.service";

export const getPlexoUrl = ({ sessionId, fingerprint }: PurchaseRequest) => {
  return (dispatch: Dispatch<GetUrlTypes>) => {
    dispatch(gettingUrl());
    return instrumentsService.getPlexoUrl({ sessionId, fingerprint }).then(
      (response) => {
        dispatch(addUrl(response, sessionId));
      },
      (error) => {
        dispatch(getUrlFailed(error));
      }
    );
  };
};

export const gettingUrl = (): GetUrlTypes => ({
  type: GETTING_URL,
});

export const addUrl = (url: string, sessionId: string): GetUrlTypes => ({
  type: GET_URL_SUCCESS,
  url,
  sessionId,
});

export const getUrlFailed = (error: string): GetUrlTypes => ({
  type: GET_URL_ERROR,
  error,
});

export const getActiveIssuers = ({ sessionId }: Session) => {
  return (dispatch: Dispatch<InstrumentTypes>) => {
    dispatch(gettingIssuer());

    return instrumentsService.getIssuers({ sessionId }).then(
      (response) => {
        dispatch(loadIssuers(response!));
      },
      (error) => {
        dispatch(getIssuersFailed(error));
      }
    );
  };
};

export const gettingIssuer = (): InstrumentTypes => ({
  type: GETTING_ISSUERS,
});

export const loadIssuers = (issuers: Issuer[]): InstrumentTypes => ({
  type: GET_ISSUERS_SUCCESS,
  issuers,
});

export const getIssuersFailed = (error: string): InstrumentTypes => ({
  type: GET_ISSUERS_ERROR,
  error,
});
